const setMaritalStatus = (val = null) => {
  return {
    type: 'SET_MARITALSTATUS',
    data: val,
  }
}

export default {
  setMaritalStatus,
}
